import React from 'react';
import { Recipe } from 'utils/grocyApi.ts';
import RecipeListItem from './RecipeListItem.tsx';
import { RecipeFulfillmentStatus } from './recipeFulfillment.ts';
import './RecipeList.css';

interface RecipeListProps {
  recipes: Recipe[];
  recipeStockStatus: Map<number, RecipeFulfillmentStatus>;
  onRecipeSelect: (recipeId: number) => void;
}

const RecipeList: React.FC<RecipeListProps> = ({
  recipes,
  recipeStockStatus,
  onRecipeSelect
}) => {
  return (
    <div className="recipe-list">
      <div className="recipe-list__container">
        {recipes.map(recipe => {
          const status = recipeStockStatus.get(recipe.id);
          if (!status) return null;
          
          return (
            <RecipeListItem
              key={recipe.id}
              recipe={recipe}
              stockStatus={status}
              onClick={() => onRecipeSelect(recipe.id)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RecipeList; 
